<div class="checkbox-toggle">
    <input type="checkbox" [id]="'tggl_' + name" (change)="updateModel($event)" [value]="value" [name]="name" [required]="required" [checked]="isChecked" [attr.aria-checked]="isChecked? 'true' : 'false'">
    <label [for]="'tggl_' + name" *ngIf="currentLabel">
			<span class="slider" aria-hidden="true"></span>
			<span [innerHTML]="currentLabel | translate"></span>
		</label>
</div>
